import { ActionIcon, Badge, Image } from "@mantine/core";
import { useClickOutside, useDisclosure } from "@mantine/hooks";
import { Suspense, lazy, useContext, useEffect, useState } from "react";
import {
  HiBars3,
  HiChevronDown,
  HiChevronUp,
  HiOutlineMagnifyingGlass,
  HiOutlineShoppingCart,
} from "react-icons/hi2";
import { useLocation } from "react-router-dom";
import CartDrawerStateContext from "../../context/CartDrawerStateContext";
import useCart, { CartItemType } from "../../hooks/useCart";
import CartNavbarDrawer from "./CartNavbarDrawer";
import NavbarProductCategoryDropdownContent from "./NavbarProductCategoryDropdownContent";
import SearchBar from "./SearchBar";
import Icon from "/icon.svg";

const SiderNavbarDrawer = lazy(() => import("./SiderNavbarDrawer"));

export default function Navbar() {
  const [isLeftDrawerOpened, { open, close }] = useDisclosure(false);
  const { pathname } = useLocation();
  const [cart] = useCart();
  const { setOpen } = useContext(CartDrawerStateContext);
  const [cartValues, setCartValues] = useState<CartItemType[] | undefined>();
  const [visibleSearch, setVisibleSearch] = useState<boolean>(false);
  const [
    isProductsCategoryDropdownOpened,
    {
      open: openProductsCategoryDropdown,
      close: closeProductsCategoryDropdown,
      toggle: toggleProductsCategoryDropdown,
    },
  ] = useDisclosure();

  /**
   * Click outside for the dropdown
   *
   */

  const dropdownContentRef = useClickOutside(() =>
    closeProductsCategoryDropdown()
  );

  /**
   * Handling close drawer whenever user is navigating
   */
  useEffect(() => {
    close();
  }, [pathname]);

  const handleOpenDrawer = () => {
    open();
  };

  const handleCloseDrawer = () => {
    close();
  };

  const handleOpenCart = () => {
    setOpen && setOpen(true);
  };
  useEffect(() => {
    if (cart !== undefined) {
      setCartValues(() => {
        return [...Array.from(cart.values())];
      });
    }
  }, [cart]);

  // const [scrollPos] = useWindowScroll();
  // const [debouncedScrollPos] = useDebouncedValue(scrollPos, 50);

  const handleVisibleSearch = () => {
    setVisibleSearch((t) => !t);
  };

  return (
    <>
      <div className="navbar-wrapper px-4 py-4 border-b border-solid bg-neutral-50 sticky top-0 z-[50] md:px-16">
        <div className="flex flex-row gap-6 items-center">
          {/* Menu */}
          <ActionIcon
            className="md:hidden"
            variant="transparent"
            onClick={handleOpenDrawer}
            color="black"
          >
            <HiBars3 size={24} />
          </ActionIcon>

          {/* Dummy button */}
          <ActionIcon className="md:hidden" variant="transparent" color="black">
            <span></span>
          </ActionIcon>
          {/* Logo */}
          <a
            href={"/"}
            className="flex-1 md:flex-initial flex md:justify-start justify-center items-center max-h-[32px]"
          >
            <Image
              src={Icon}
              w={128}
              h={120}
              className="ease-in-out transition-all delay-duration-300"
            />
          </a>

          {/* Navbar links and search bar */}
          <div className="hidden md:block navbar-links flex-1 text-sm">
            <ul className="font-bold text-neutral-600 flex flex-row gap-5">
              <li>
                <a href="/">Trang chủ</a>
              </li>
              <li>
                <div className="flex flex-row gap-1 items-center">
                  <a href="/product">Sản phẩm</a>
                  <button
                    onClick={() => {
                      if (!isProductsCategoryDropdownOpened) {
                        openProductsCategoryDropdown();
                      }
                    }}
                  >
                    {!isProductsCategoryDropdownOpened ? (
                      <HiChevronDown />
                    ) : (
                      <HiChevronUp />
                    )}
                  </button>
                </div>
              </li>
            </ul>
          </div>

          {/* Search bar */}
          {/* <Input
          className="flex-1"
          leftSection={<HiMagnifyingGlass />}
          placeholder="Tìm kiếm sản phẩm"
        /> */}
          {/* Search btn */}
          <div>
            <ActionIcon
              variant="transparent"
              color="black"
              onClick={handleVisibleSearch}
            >
              <HiOutlineMagnifyingGlass size={24} />
            </ActionIcon>
          </div>
          {/* Cart btn */}
          <div className="h-full relative" onClick={handleOpenCart}>
            <ActionIcon
              variant="transparent"
              // onClick={handleOpenCart}
              color="black"
            >
              <HiOutlineShoppingCart size={24} />
            </ActionIcon>
            {/* Badge for cart count */}
            {cartValues && cartValues?.length !== 0 && (
              <Badge
                className="absolute -top-[4px] -left-[4px] bg-primary"
                circle
                size="xs"
              >
                {cart.size}
              </Badge>
            )}
          </div>
        </div>
      </div>

      {/* Search bar */}
      {visibleSearch && (
        <div className="bg-neutral-50 px-2 py-2 border-b border-solid transition-all ease-in-out">
          <SearchBar />
        </div>
      )}

      {/* Drop down for products, only on wide-screen */}
      {isProductsCategoryDropdownOpened && (
        <div
          className="min-h-[40vh] shadow-md mx-1 rounded-md border-neutral-400 border-solid p-4 sticky top-16 z-[9999] bg-neutral-100 transition-all ease-in-out"
          ref={dropdownContentRef}
        >
          <NavbarProductCategoryDropdownContent />
        </div>
      )}

      <Suspense fallback={<></>}>
        <SiderNavbarDrawer
          opened={isLeftDrawerOpened}
          onClose={handleCloseDrawer}
        />
      </Suspense>
      <CartNavbarDrawer />
    </>
  );
}
